import * as React from "react";
import { styled } from "@mui/material/styles";
import Logo from "../Assets/Logo.svg";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { Link, useNavigate } from "react-router-dom";
import { AccountCircle } from "@mui/icons-material";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../redux/reducer/rootReducer";
import { Box, Button } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { Dispatch } from "@reduxjs/toolkit";
import { logout } from "../services/auth/auth";
import StoreIcon from "@mui/icons-material/Store";
import WhatshotIcon from "@mui/icons-material/Whatshot";
const AppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 2,
}));

export const AppTopbar: React.FunctionComponent = () => {
  const portalUrl = useSelector(
    (state: AppState) => state.shoppingPortalReducer.storeUrl
  );
  const name = useSelector((state: AppState) => state.authReducer.name);
  const partsPortalCustomerName = useSelector(
    (state: AppState) => state.authReducer.customerData?.firstName
  );
  const dispatch = useDispatch<Dispatch<any>>();
  let navigate = useNavigate();
  const userType = useSelector((state: AppState) => state.authReducer.userType);
  const { setupId } = useSelector((state: AppState) => state.authReducer);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const Logout = () => {
    setAnchorEl(null);
    dispatch(logout());
    navigate(userType === "Admin" ? "/AdminLogin" : "/");
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };
  const handleNavigateToPartsPortal = () => {
    window.open("/ShoppingPortal/Parts?store=" + portalUrl, "_blank");
    handleClose();
  };

  return (
    <>
      <AppBar position="fixed" style={{ backgroundColor: "white" }}>
        <Toolbar>
          <Typography noWrap component="div" sx={{ flexGrow: 1, mt: 2 }}>
            <img style={{ maxWidth: "200px" }} src={Logo}></img>
          </Typography>
          <div>
            <Box
              display="flex"
              justifyContent="flex-end"
              flexDirection="row"
              alignItems="center"
            >
              {userType === "User" && setupId ? (
                <Button
                  variant="outlined"
                  startIcon={<WhatshotIcon fontSize="small" />}
                  className="beamerTrigger"
                  sx={{ mr: 2 }}
                >
                  What's New
                </Button>
              ) : null}
              {userType === "PortalCustomer" ? (
                <Typography style={{ color: "#38376e" }} fontWeight={"bold"}>
                  Hi {partsPortalCustomerName}
                </Typography>
              ) : (
                <Typography style={{ color: "#38376e" }} fontWeight={"bold"}>
                  Hi {name}
                </Typography>
              )}
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                style={{ color: "#38376e" }}
              >
                <AccountCircle />
              </IconButton>
            </Box>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {userType === "Customer" ? (
                <MenuItem
                  component={Link}
                  to={"/Customer/Profile"}
                  onClick={handleClose}
                  sx={{ fontSize: "14px" }}
                >
                  <AccountCircle fontSize="small" sx={{ marginRight: 1 }} />{" "}
                  Profile
                </MenuItem>
              ) : (
                ""
              )}
              {userType === "PortalCustomer" ? (
                <MenuItem
                  onClick={handleNavigateToPartsPortal}
                  sx={{ fontSize: "14px" }}
                >
                  <StoreIcon fontSize="small" sx={{ marginRight: 1 }} /> Parts
                  Portal
                </MenuItem>
              ) : (
                ""
              )}
              {userType === "User" && setupId ? (
                <MenuItem
                  component={Link}
                  to={"/SetupProfile"}
                  onClick={handleClose}
                  sx={{ fontSize: "14px" }}
                >
                  <AccountCircle sx={{ marginRight: 1 }} fontSize="small" />{" "}
                  Profile
                </MenuItem>
              ) : (
                ""
              )}
              <MenuItem onClick={Logout} sx={{ fontSize: "14px" }}>
                <LogoutIcon sx={{ marginRight: 1 }} fontSize="small" /> Log Out
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    </>
  );
};
